import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import Constants from "../../../Action/Constants";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import LinkSendWillMount from "../../../Middleware/Middlewares/LinkSendWillMount";
import PreventPageLeave from "../../../Middleware/Middlewares/PreventPageLeave";

import Card from '@material-ui/core/Card';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';

import CreatableSelect from 'react-select/creatable';

class LinkSend extends Component {
  protected shouldClearBeforeUnmounting: boolean = true;
  protected clearWith: string = Constants.GLOBAL_EMAIL_SEND_CLEAR;
  protected middlewares: MiddlewareInterface[] = [
    LinkSendWillMount,
    PreventPageLeave
  ];

  public state = {
    userId: null,
    userType: "",
		person: null,
		emailTo: "",
		message: "",
    hasModifiedData: false,
    isSaving: false,
    openLeavePrompt: false,
  }

  constructor(public props) {
    super(props);
	}

	public onChange = (valObject) => {
		this.setState({
      emailTo: valObject?.value,
      hasModifiedData: true
		});
  }

  public save = () => {
    const email: any = {
			email: this.state.emailTo,
      message: this.state.message
    }

    if (this.state.userType  === "owner") {
			email.ownerId = this.state.person?.company?.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_LINK_SEND_START,
        payload: {
          ...email
        },
        onSuccess: () => {
          this.redirectBack();
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    })
  }

  public onDiscard = () => {
    this.setState({openLeavePrompt: false}, this.leave.bind(this))
  }

  public openCancelDialog = () => {
    this.setState({openLeavePrompt: true})
  }

  public render() {
    const emailList = [this.state.person]
											.map(person => {
												return ({
														value: person.email,
														label: `${person.displayName} (${person.email})`
													});
												}
											);

		const customStyles = {
      control: (base, state) => {
        let borderColor = 'rgba(0, 0, 0, 0.23)';
        let boxShadow = 'none !important';
        let outlineColor = "auto";

        if (state.isFocused) {
          borderColor = "#00BCD4 !important";
          boxShadow = "0 0 1px 1px #00BCD4 !important";
          outlineColor = "#00BCD4 !important";

          if (!!this.getErrorFor("to")) {
            borderColor = "#f44336 !important";
            boxShadow = "0 0 1px 1px #f44336 !important";
            outlineColor = "#f44336 !important";
          }
        } else {
          if (!!this.getErrorFor("to")) {
            borderColor = "#f44336 !important";
            outlineColor = "#f44336 !important";
          }
        }

        return ({
          ...base,
          border: state.isFocused ? 'none !important' : "auto",
          borderColor: borderColor,
          boxShadow: boxShadow,
          outlineColor: outlineColor,
          outlineStyle: state.isFocused ? "auto !important" : "auto",
          outlineWidth: state.isFocused ? "5px !important"  : "auto",
          '&:hover': {
            borderColor: !!this.getErrorFor("to") ? '#f44336' : 'black',
          }, // border style on hover
        });
      }
    }

    return (
      <div className="state-app">
        <div className="box box-full has-details-page-header">
          <div className="component-header has-back-button">
            <div className="inner-wrapper">
              <div className="back-arrow-wrapper" onClick={this.state.hasModifiedData ? this.openCancelDialog : this.onDiscard}>
                <div className="icon icon-ic-arrow-back icon-color"></div>
              </div>
              <h1>{this.trans("page/sendemail-title/sendemail")}</h1>
              <div className="button-container-small">
                <Button
                  color="primary"
                  onClick={this.state.hasModifiedData ? this.openCancelDialog : this.onDiscard}
                  style={{marginRight: "20px"}}
                  disabled={this.state.isSaving}
                >
                  {this.trans("button-cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.save}
                  disabled={this.state.isSaving}
                >
                  {this.trans("button-send")}
                </Button>
              </div>
            </div>
          </div>

          <div className="box component-send-email">
            <div className="component-wrapper no-margin-top no-shadow">
              <div className="component">
                <Card className="card">
                  <div className="row">
                    <div className="grid"></div>
                    <div className="grid">
											<div style={{position: "relative", zIndex: 2}}>
												<CreatableSelect
                          options={emailList}
                          defaultValue={emailList[0]}
													onChange={this.onChange}
                          styles={customStyles}
                          placeholder={this.trans("mail")}
                          className="form-element scroll-to-to"
                          minMenuHeight={40}
                          maxMenuHeight={window.innerHeight - 280 < 40 ? 40 : window.innerHeight - 280}
												/>
                        {!!this.getErrorFor("to") && <div className="component-error-text">{this.getErrorFor("to")}</div>}
											</div>

                      <TextField
                        autoComplete="off"
                        className="form-element full-size scroll-to-message"
                        type="text"
                        label={this.trans("message") + this.trans("field/optional")}
                        value={this.state.message}
                        onChange={this.sync.bind(this, this.syncronizers.EVENT, "message")}
                        variant="standard"
                        multiline
                        rowsMax="25"
                        error={!!this.getErrorFor("message")}
                      />
                      {!!this.getErrorFor("message") && <div className="component-error-text">{this.getErrorFor("message")}</div>}
                    </div>
                  </div>
                </Card>
              </div>
            </div>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.openLeavePrompt}
          title={this.trans("dialog/attention-title") + "!"}
          content={this.trans("page/sendemail-dialog/attention-info")}
          positiveButtonLabel={this.trans("dialog-button/cancel")}
          negativeButtonLabel={this.trans("dialog/sendemail-button/donotcancel")}
          onSave={this.onDiscard}
          onDiscard={() => { this.setState({ openLeavePrompt: false }) }}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    component: state.emailSend,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  LinkSend
);
